/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { dropTask } from 'ember-concurrency';
import clientQuery from 'my-phorest/gql/queries/client.graphql';
import { queryManager } from 'ember-apollo-client';

export default class ChatsListComponent extends Component {
  @service intl;
  @service notifications;
  @service session;
  @service twoWayChat;
  @service whatsapp;
  @queryManager apollo;

  @tracked showInfoModal = false;
  @tracked showAiSettingsModal = false;

  @action
  async selectConversation(conversation) {
    const { clientId } = conversation;
    const client = await this.apollo.query(
      {
        query: clientQuery,
        variables: {
          id: clientId,
        },
      },
      'client'
    );

    this.twoWayChat.selectClient(client, conversation);
    this.twoWayChat.setNextScreen('client-chat');
  }

  @action
  async copyToClipboard(text) {
    try {
      await navigator.clipboard.writeText(text);
      this.notifications.success(
        this.intl.t('two-way-chat.successfully-copied-to-clipboard')
      );
    } catch (err) {
      console.error('Failed to copy phone number to clipboard', err);
      this.notifications.failure(
        this.intl.t('two-way-chat.failed-to-copy-to-clipboard')
      );
    }
  }

  @action
  changeTab(tab) {
    if (tab !== this.twoWayChat.selectedTab) {
      this.twoWayChat.selectedTab = tab;
      this.twoWayChat.getChatConversationsTask.perform();
    }
  }

  @action
  openAiSettingsModal() {
    this.showAiSettingsModal = true;
  }

  @action
  closeAiSettingsModal() {
    this.showAiSettingsModal = false;
  }

  @dropTask
  *saveAiSettingsTask(settingsObject) {
    yield this.twoWayChat.updateBranchAiSettingsTask.perform(
      settingsObject.aiEnablementMode,
      settingsObject.testClientIds
    );
    this.closeAiSettingsModal();
  }
}
